'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("circle", {
    id: "realty-type-site_svg__a",
    cx: 28,
    cy: 28,
    r: 28
  })), /*#__PURE__*/React__namespace.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "realty-type-site_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#realty-type-site_svg__a"
  })), /*#__PURE__*/React__namespace.createElement("use", {
    fill: "#FCD863",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 -1 0 56)",
    xlinkHref: "#realty-type-site_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    mask: "url(#realty-type-site_svg__b)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m15.418 22.077.933.228a12.324 12.324 0 0 0 1.236 8.975l.118.203-.827.489a13.281 13.281 0 0 1-1.46-9.895Zm1.783 1.23.943.182a10.186 10.186 0 0 0 .648 5.943l.092.206-.873.4a11.145 11.145 0 0 1-.81-6.73Zm22.644 4.724.928.247c-.11.414-.24.824-.392 1.23l-.118.304-.891-.356c.188-.47.346-.945.473-1.425Zm.38-2.27.958.07c-.027.385-.072.77-.134 1.154l-.05.288-.944-.175c.082-.443.139-.89.17-1.336Zm.927-2.189c.033.331.054.665.062 1l.004.335-.96-.001c0-.312-.011-.622-.034-.93l-.027-.308.955-.096Zm-2.087-.438c.049.354.08.708.094 1.064l.007.266-.96.014a10.029 10.029 0 0 0-.055-.911l-.037-.303.951-.13Zm-3.263-8.943a13.28 13.28 0 0 1 5.196 8.296l.04.226-.947.158a12.325 12.325 0 0 0-4.677-7.772l-.179-.134.567-.774Zm-17.974 7.013.888.364c-.116.283-.219.57-.308.86l-.085.293-.926-.255c.118-.428.262-.85.43-1.262Zm17.695-4.885a11.14 11.14 0 0 1 3.34 5.643l.051.225-.938.205a10.18 10.18 0 0 0-2.933-5.209l-.166-.154.646-.71Zm-19.407 3.67.882.38c-.122.283-.233.572-.334.866l-.097.295-.916-.288c.134-.427.29-.845.465-1.253Zm1.131-2.089.8.531c-.188.282-.363.57-.525.866l-.158.296-.854-.44c.222-.43.468-.848.737-1.253Zm1.676-2.045.679.678a12.47 12.47 0 0 0-.808.89l-.188.233-.755-.592a13.41 13.41 0 0 1 1.072-1.21Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFF",
    d: "m24.895 37.901 3.812 2.773 13.598-5.825-3.9-2.824M31.588 31.294l-4.39-2.525L13.6 34.594l4.46 2.565"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M15.425 2.753a8.537 8.537 0 0 0-6.364 14.228l5.61-2.403 4.39 2.526 2.37.254a8.538 8.538 0 0 0-6.006-14.605",
    fill: "#3F3E4B",
    opacity: 0.2,
    style: {
      mixBlendMode: 'multiply'
    },
    transform: "translate(12.528 14.19)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m31.739 30.827-4.51-2.594-14.701 6.298 5.38 3.094 6.808.74 3.93 2.858 14.627-6.266-4.69-3.395-6.844-.735Zm-17.067 3.83 12.495-5.353 4.27 2.457 6.79.728 3.11 2.252-12.569 5.384-3.694-2.687-6.864-.746-3.538-2.035Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M28.212 34.755c.158-4.519 4.485-5.638 4.485-9.331a4.746 4.746 0 0 0-5.358-4.706c-2.474.311-4.302 2.557-4.118 5.044.254 3.428 4.32 4.615 4.473 8.993",
    fill: "#BFBEC8"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M27.279 20.242c3.153-.396 5.898 2.043 5.898 5.182 0 1.454-.51 2.496-1.71 3.966l-.222.267-.426.505c-1.43 1.7-2.027 2.8-2.12 4.438l-.008.172-.739-.026-.738.026c-.058-1.678-.61-2.775-1.983-4.436l-.66-.786c-1.194-1.434-1.73-2.412-1.829-3.753-.202-2.743 1.811-5.213 4.537-5.555Zm4.938 5.182a4.266 4.266 0 0 0-4.819-4.23c-2.217.279-3.863 2.298-3.698 4.532.074 1.008.465 1.789 1.371 2.92l.292.354.458.544c1.104 1.313 1.769 2.33 2.1 3.488l.031.12.033-.12c.316-1.105.936-2.083 1.952-3.31l.66-.787c1.164-1.398 1.62-2.285 1.62-3.511Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M29.392 25.481a1.44 1.44 0 1 1-2.879 0 1.44 1.44 0 0 1 2.88 0",
    fill: "#FFF"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M27.953 23.562a1.92 1.92 0 1 0 0 3.84 1.92 1.92 0 0 0 0-3.84Zm0 .96a.96.96 0 1 1 0 1.92.96.96 0 0 1 0-1.92Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }))));
});
var RealtyTypeSite = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.RealtyTypeSite = RealtyTypeSite;